module.exports = [{
      plugin: require('/app/packages/landing/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
